export default {
  loadBtn: false,

  socialNetworks: [],

  date: {},

  language: [],

  changeLanguage: false,

  menuPosition: [],

  headerMenu: [],

  footerMenu: [],

  config: [],

  aboutUs: [],

  contactUs: [],

  captcha: {},

  categories: [],
  bookPublisher: [],
  publishers: [],
  authors: [],

  blogs: [],
  blog: {},

  comments: [],
  commentsLength: [],

  medias: [],
  media: {},
  mediaGallery: {},

  mediaComments: [],
  mediaCommentsLength: [],

  photos: [],
  photo: {},
  photosGallery: {},

  photoComments: [],
  photoCommentsLength: [],

  books: [],
  bookGallery: {},

  bookComments: [],
  bookCommentsLength: [],

  sounds: [],
  sound: [],
  soundGallery: {},

  soundComments: [],
  soundCommentsLength: [],

  bookContents: [],

  bookDetails: [],

  search: [],
};
